import { ReactNode } from 'react';
import { Loader } from 'rsuite';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@hooks/useAuth';
import { useAccess } from '@hooks/useAccess';

interface ProtectedRouteProps {
  children: ReactNode;
  /**
   * Nivel mínimo requerido para acceder (0: USER, 1: ADMIN, 2: OWNER, 3: DEV)
   * Por defecto 0 (cualquier usuario autenticado)
   */
  requiredLevel?: number;
}

export const ProtectedRoute = ({ children, requiredLevel = 0 }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading } = useAuth();
  const { loading: permLoading, canAccess, hasLevel, role } = useAccess();
  const location = useLocation();

  if (isLoading || permLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: '16px'
      }}>
        <Loader size="lg" />
        <p style={{ color: '#6b7280', fontSize: '16px' }}>Verificando acceso...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Verificar nivel de acceso requerido
  if (!hasLevel(requiredLevel)) {
    return (
      <Navigate 
        to="/dashboard" 
        replace 
        state={{ 
          from: location,
          error: `Acceso denegado. Se requiere nivel ${requiredLevel} y tu rol actual (${role}) no tiene suficientes permisos.`
        }} 
      />
    );
  }

  // Verificar acceso a la ruta específica
  const path = location.pathname;
  if (!canAccess(path)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
